import type { FulfillmentJob } from '@/services';

/**
 * Server-computed job display name (`#1016-0713` form); never reconstruct
 * the bag-number format on the client. Shared by the order structure tree
 * (OrderDetailExtra) and the per-order trace timeline (TraceTimeline) so
 * both render the same operator-facing label — and so neither has to
 * import the other (which would form a module cycle). Falls back through
 * `name → shopify_order_name → id` so a core-written job with a null
 * `name` still surfaces a real order label.
 */
export function jobDisplayName(job: FulfillmentJob): string {
  return job.name || job.shopify_order_name || job.id;
}
